/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_Permissions_UpdatedInputs */



/**
* | output |
* | --- |
* | "Guide permissions updated" |
*
* @param {Knp_Manager_Permissions_UpdatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_permissions_updated = /** @type {((inputs?: Knp_Manager_Permissions_UpdatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Permissions_UpdatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autorisations du guide mises à jour")
	if (locale === "de") return /** @type {LocalizedString} */ ("Berechtigungen für den Leitfaden aktualisiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Autorizzazioni della guida aggiornate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновлены разрешения для гида.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Permisos de guía actualizados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向导权限已更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ガイド権限が更新されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गाइड की अनुमतियाँ अपडेट कर दी गईं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Permissões do guia atualizadas")
	return /** @type {LocalizedString} */ ("Guide permissions updated")
});